import React from 'react';
import { Image as ImageRenderer } from '@react-pdf/renderer';

const Image = ({source, ...rest}) => {
    return source ? <ImageRenderer source={source} {...rest} /> : null; 
};
  
export default Image